import styled from 'styled-components';
import BgBidWinner from 'assets/images/bg-bid-winner.png';

export const Container = styled.div`
  .close {
    position: absolute;
    right: 21px;
    top: 19px;
    z-index: 11;
    color: black;
  }

  .bg-modal {
    background-image: url('${BgBidWinner}');
    background-size: 100%;
    background-repeat: no-repeat;
  }

  .btn-seguro-garantia {
    background-color: #52b900;
    color: #fff;
    border: none;
    border-radius: 25px;
  }
`;
